import { Category, CategoryMap } from '@olxpwa-lib/categories';
import { getCategoryPath } from './getCategories';

export const trackCategories = (
    categories: CategoryMap,
    adCategoryId: number | null
) => {
    if (!adCategoryId) return {};
    const categoryData = categories[adCategoryId];
    const ancestors = getCategoryPath(
        categories,
        categoryData ? categoryData : ({} as Category)
    );
    return (
        ancestors.reduce((result, category, index) => {
            const level = index + 1;
            result[`cat_l${level}_id`] = category.id;
            result[`cat_l${level}_name`] = category.normalizedName;
            return result;
        }, {} as Record<string, string | number>) || null
    );
};
